<script lang="ts">
	import { onMount } from 'svelte'
	import { page } from '$app/stores'
	import {
		storeCookieSelection
	} from '$lib/js/stores'
	import { PUBLIC_ADWORDS_TAG_ID, PUBLIC_ANALYTICS_TAG_ID } from '$env/static/public'

	onMount(() => {
		gtag('config', PUBLIC_ANALYTICS_TAG_ID, {
			transport_type: 'beacon',
			send_page_view: false,
		})
		// For ads tracking
		gtag('config', PUBLIC_ADWORDS_TAG_ID, { transport_type: 'beacon' })


		if ($storeCookieSelection){
			gtag('consent', 'update', $storeCookieSelection)
		}

	})

	$: if (typeof window != 'undefined' && typeof gtag !== 'undefined') {
		gtag('event', 'page_view', {
			page_title: document.title,
			page_location: $page.url.pathname,

			// @ts-ignore
		})
	}
</script>

<!-- svelte-ignore missing-declaration -->
<svelte:head />
